import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getShiftHandoverTimesheetRef = createSelector(
  [getWorkOrderManagement],
  (management) => {
    return management.shiftHandoverTimesheetRef;
  }
);

export const getShiftHandoverSource = createSelector(
  [getWorkOrderManagement],
  (management) => {
    return management.shiftHandoverSource;
  }
);

export const getShiftHandoverOperator = createSelector(
  [getWorkOrderManagement],
  (management) => {
    return management.shiftHandoverOperator;
  }
);
